import './style.css'

const InsigthNumber = ({ data, lable, icon, trend, trendValue, href = '#' }) => {
    return (
        <div className='number-card'>
            <div className='card-header'>
                <div className='info-section'>
                    <p className='trend-label'>{lable}</p>
                    <h2 className='trend-data'>{data}</h2>
                    {trend && (
                        <div className={`trend-indicator ${trend}`}>
                            <span className="trend-percentage">
                                {trend === 'up' ? '↗' : trend === 'down' ? '↘' : ''} {trendValue}
                            </span>
                            <span className="trend-text"> vs anterior</span>
                        </div>
                    )}
                    {!trend && (
                        <div className="trend-indicator stable">
                            <span className="trend-text">Estable</span>
                        </div>
                    )}
                </div>
                <div className='card-icon-box'>
                    {icon}
                </div>
            </div>
        </div>
    )
}

export default InsigthNumber
